import { RegisterFormFields } from '../../ui/register-step/types';
import { RegisterFormKeys } from '../../config/form-register-constants';
import { RegisterUserRequestData } from '../../api/register-types';
import { OrganizationSuggestItem } from '@shared/model/organization';
import { UTMInfoKeysEnum } from '@entities/current-user/api/credentials-user-types';

export const convertFormFields = ({
    fields,
    organization,
    utmData,
}: {
    fields: RegisterFormFields;
    organization: OrganizationSuggestItem;
    utmData: Partial<Record<UTMInfoKeysEnum, string>> | null;
}): RegisterUserRequestData => {
    const departmentOption = fields[RegisterFormKeys.Department][0];
    return {
        email: fields[RegisterFormKeys.Email],
        profile: {
            lastName: fields[RegisterFormKeys.Surname],
            firstName: fields[RegisterFormKeys.Name],
            middleName: fields[RegisterFormKeys.Patronymic],
            phoneNumber: fields[RegisterFormKeys.Phone],
            company: {
                fullName: organization.fullName,
                shortName: organization.shortName,
                inn: organization.inn,
                kpp: organization.kpp,
                address: organization.address,
            },
            departmentId: departmentOption ? Number(departmentOption.value) : 0,
            jobTitle: fields[RegisterFormKeys.JobTitle],
            receivingPromotionalMaterials: fields[RegisterFormKeys.AgreementAdvert],
        },
        utmData,
    };
};
